import { render, staticRenderFns } from "./FeedTxItems.vue?vue&type=template&id=60765a4d&"
import script from "./FeedTxItems.vue?vue&type=script&lang=js&"
export * from "./FeedTxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports